import { render } from "./purchase-orders.vue?vue&type=template&id=21aaef3e&scoped=true"
import script from "./purchase-orders.vue?vue&type=script&lang=js"
export * from "./purchase-orders.vue?vue&type=script&lang=js"

import "./purchase-orders.vue?vue&type=style&index=0&id=21aaef3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21aaef3e"]])

export default __exports__